/*=========================================================================================
  File Name: themeConfig.js
  Description: Theme configuration
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: hhttp://www.themeforest.net/user/pixinvent
==========================================================================================*/

// MAIN COLORS - VUESAX THEME COLORS
let colors = {
  // primary : '#b9acf0',
  primary: '#6252dd',
  success: '#00ac8b',
  danger: '#f95448',
  warning: '#f7b731',
  dark: '#1E1E1E',
};

import Vue from 'vue';
import Vuesax from 'vuesax';

Vue.use(Vuesax, { theme: { colors } });


// CONFIGS
const themeConfig = {
  disableCustomizer: false,       // options[Boolean] : true, false(default)
  disableThemeTour: false,        // options[Boolean] : true, false(default)
  footerType: 'static',    // options[String]  : static(default) / sticky / hidden
  hideScrollToTop: false,       // options[Boolean] : true, false(default)
  mainLayoutType: "vertical",  // options[String]  : vertical(default) / horizontal
  navbarColor: "#fff",      // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
  navbarType: "sticky",  // options[String]  : floating(default) / static / sticky / hidden
  routerTransition: "slide-fade", // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
  sidebarCollapsed: false,       // options[Boolean] : true, false(default)
  theme: 'semi-dark',     // options[String]  : "light"(default), "dark", "semi-dark"
  minSupportedResolution: import.meta.env.VITE_SITE_MIN_SUPPORTED_RESOLUTION || 1200,
  userInfoLocalStorageKey: 'userInfo',
  colors
};

export default themeConfig;
